import { getJson, patchJson } from "./apiClient";

export const userProfileQueryKey = ["user-profile"];

export const userProfileService = {
  get,
  update,
};

function get() {
  return getJson("/api/v1/user-profile/");
}

function update(payload) {
  return patchJson("/api/v1/user-profile/", payload);
}
